/** Формат времени письма: ЧЧ:ММ если сегодня, иначе ДД.ММ.ГГГГ (как на макетах). */
export function formatMessageTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  if (sameDay) {
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  }
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/** Полная дата письма (детальный экран): ДД.ММ.ГГГГ. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/** Остаток до expiresAt в формате ММ:СС (бейдж «Активен ещё 23:18»). null если истёк/нет. */
export function formatRemaining(
  expiresAt: string | null | undefined,
  nowMs: number = Date.now(),
): string | null {
  if (!expiresAt) return null;
  const diffMs = new Date(expiresAt).getTime() - nowMs;
  if (diffMs <= 0) return null;
  const totalSec = Math.floor(diffMs / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Размер вложения: «1.03 Мб» / «512 Кб». */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${String(bytes)} Б`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(0)} Кб`;
  return `${(kb / 1024).toFixed(2)} Мб`;
}

/** Дата для текстов вида «восстановится 15.07.2026». */
export function formatLongDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
